import { Injectable } from '@angular/core';

const PKCE_VERIFIER_KEY = 'iam_pkce_code_verifier';
const PKCE_STATE_KEY = 'iam_pkce_state';

@Injectable({ providedIn: 'root' })
export class OAuthPkceService {
  generateCodeVerifier(): string {
    const array = new Uint8Array(64);
    crypto.getRandomValues(array);
    return this.base64UrlEncode(array);
  }

  async generateCodeChallenge(verifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await crypto.subtle.digest('SHA-256', data);
    return this.base64UrlEncode(new Uint8Array(digest));
  }

  generateState(): string {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return this.base64UrlEncode(array);
  }

  storeVerifier(verifier: string): void {
    sessionStorage.setItem(PKCE_VERIFIER_KEY, verifier);
  }

  getVerifier(): string | null {
    return sessionStorage.getItem(PKCE_VERIFIER_KEY);
  }

  clearVerifier(): void {
    sessionStorage.removeItem(PKCE_VERIFIER_KEY);
  }

  storeState(state: string): void {
    sessionStorage.setItem(PKCE_STATE_KEY, state);
  }

  getState(): string | null {
    return sessionStorage.getItem(PKCE_STATE_KEY);
  }

  clearState(): void {
    sessionStorage.removeItem(PKCE_STATE_KEY);
  }

  clearAll(): void {
    this.clearVerifier();
    this.clearState();
  }

  private base64UrlEncode(buffer: Uint8Array): string {
    const base64 = btoa(String.fromCharCode(...buffer));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
}
